<template>
  <div>
      
    <b-tabs content-class="mt-3">
        
    <b-tab title="Cuotas Pendientes" active>
        <b-row class="pb-3">
        <!-- year select -->
            <b-col cols="auto">
                Año
                <b-form-select v-model="selectedYear" id="yearSelected" :options="yearOptions"></b-form-select>
            </b-col>
            <b-col cols="auto">
                Mes Desde
                <b-form-select v-model="selectedDesde" id="yearSelected" :options="monthsOptions"></b-form-select>
            </b-col>
            <b-col cols="auto">
                Mes Hasta
                <b-form-select v-model="selectedHasta" id="yearSelected" :options="monthsOptions"></b-form-select>
            </b-col>
            <b-col cols="auto">
                <b-button class="mt-4" @click="refrescarListado()">r</b-button>
            </b-col>
            <b-col cols="auto" class="pt-4">
              {{cantidadFacturas}} facturas pendientes por un monto total de $ {{montoTotalFacturas}}
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-table :items="accountMoves" :fields="accountMovesFields">
                  <template #cell(invoice_origin)="data">
                    <b-link
                      @click="verVentaFromAccount(data.item.invoice_origin)"
                      >{{ data.item.invoice_origin }}</b-link
                    >
                  </template>
                </b-table>
            </b-col>
        </b-row>
    </b-tab>
    <b-tab title="Cuenta Corriente">
        
    </b-tab>
  </b-tabs>
  <b-modal id="modal-ver-venta" size="xl" :title="modalSaleOrderTitle">
    <ver-venta :order_id="modalSaleOrderId" :family="family"></ver-venta>
  </b-modal>
  </div>
</template>

<script>
import VerVenta from './VerVenta.vue'
import { AccountMoveService } from '@/services/account.move.service'
import { SaleOrdersService } from '@/services/sale.orders.service'
import { FamiliesService } from '@/services/families.service'
import moment from 'moment'

export default {
  name: 'BillingPage',
  data () {
    return {
      name: 'asd',
      years: [],
      year: {},
      selectedYear: null,
      selectedDesde: moment().format('MM'),
      selectedHasta: moment().format('MM'),
      accountMoves: [],
      accountMovesFields: [
        { key: 'invoice_date_due', label: 'Fecha Venc.' },
        { key: 'invoice_origin', label: 'Venta' },
        { key: 'partner_id', label: 'Familia' },
        { key: 'amount_total', label: 'Total' }
      ],
      monthsWithDebt: [],
      monthsOptions: [
        { value: '01', text: 'Enero' },
        { value: '02', text: 'Febrero' },
        { value: '03', text: 'Marzo' },
        { value: '04', text: 'Abril' },
        { value: '05', text: 'Mayo' },
        { value: '06', text: 'Junio' },
        { value: '07', text: 'Julio' },
        { value: '08', text: 'Agosto' },
        { value: '09', text: 'Septiembre' },
        { value: '10', text: 'Octubre' },
        { value: '11', text: 'Noviembre' },
        { value: '12', text: 'Diciembre' }
      ],
      modalSaleOrderId: null,
      modalSaleOrderTitle: '',
      family: {}
    }
  },
  components: {
    VerVenta
  },
  computed: {
    yearOptions () {
      const opts = []
      for (var i = 0; i < this.years.length; i++) {
        opts.push({ value: this.years[i].id, text: this.years[i].x_year })
      }
      return opts
    },
    fechaDesde () {
      return moment(this.year.x_year + '-' + this.selectedDesde).startOf('month').format('YYYY-MM-DD')
    },
    fechaHasta () {
      return moment(this.year.x_year + '-' + this.selectedHasta).endOf('month').format('YYYY-MM-DD')
    },
    cantidadFacturas () {
      return this.accountMoves.length
    },
    montoTotalFacturas () {
      let total = 0
      for (let i = 0; i < this.accountMoves.length; i++) {
        total += parseInt(this.accountMoves[i].amount_total)
      }
      return total
    }
  },
  async created () {
    this.years = this.$store.state.year.list
    this.year = this.$store.state.year.selected
    this.selectedYear = this.year.id
    console.log(this.year)
    // this.projectList = await ProjectsService.list()
    console.log(this.fechaDesde)
    this.accountMoves = await AccountMoveService.list([
      ['state', '=', 'draft'],
      ['invoice_date_due', '>', this.fechaDesde],
      ['invoice_date_due', '<', this.fechaHasta]], ['invoice_date_due', 'invoice_origin', 'partner_id', 'amount_total'])
  },
  methods: {
    async refrescarListado () {
      this.accountMoves = await AccountMoveService.list([
        ['state', '=', 'draft'],
        ['invoice_date_due', '>', this.fechaDesde],
        ['invoice_date_due', '<', this.fechaHasta]])
      console.log(this.accountMoves)
    },
    async verVentaFromAccount (item) {
      const so = await SaleOrdersService.list({ name: item })
      this.family = (await FamiliesService.read(
        [parseInt(so[0].partner_id[0])],
        []
      ))[0]
      
      this.modalSaleOrderId = so[0].id
      this.modalSaleOrderTitle =
        this.family.name +
        ' - ' +
        so[0].display_name +
        ' - ' +
        so[0].create_date
      this.$bvModal.show('modal-ver-venta')
    }
  }
 
}
</script>

<style lang="scss" scoped>

</style>
